import Vue from "vue";
import Vuelidate from "vuelidate";
import { Table, TableColumn, Carousel, CarouselItem } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as config from "@/shared/config/config";
import Donut from "vue-css-donut-chart";
import "vue-css-donut-chart/dist/vcdonut.css";
import App from "./App.vue";
import router from "./router";
import SeaHeader from "./components/SeaHeader.vue";
import SeaPage from "./components/SeaPage.vue";
import SeaPageContent from "./components/SeaPageContent.vue";
import YearSelect from "./components/YearInput.vue";
import CheckIcon from "@/components/CheckIcon.vue";
import SeaSnackbar from "./components/SeaSnackbar.vue";
import { setupAxiosInterceptors } from "@/shared/config/axios-interceptor";
import "./assets/css/global.scss";
import "./filters"

Vue.config.productionTip = false;
Vue.use(Vuelidate);
  
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
Vue.component(CheckIcon.name, CheckIcon);
Vue.component(SeaHeader.name, SeaHeader);
Vue.component(YearSelect.name, YearSelect);
Vue.component(SeaSnackbar.name, SeaSnackbar);
Vue.component(SeaPage.name, SeaPage);
Vue.component(SeaPageContent.name, SeaPageContent);

Vue.use(Donut);

const store = config.initVueXStore(Vue);
const vuetify = config.initVuetify(Vue);

setupAxiosInterceptors(() => store.dispatch("account/doLogout"));

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/not-found");
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    store
      .dispatch("account/hasAnyAuthorityAndCheckAuth", to.meta.authorities)
      .then(value => {
        if (!value) {
          sessionStorage.setItem("requested-url", to.fullPath);
          next("/forbidden");
        } else {
          next();
        }
      });
  } else {
    // no authorities, so just proceed
    next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
